import tmhRequest from '@/config/tmhRequest'


export default {
    searchSummaryAdviserPerformanceReportCount: function (data) {
        return tmhRequest({
            url: '/report/ispa/summaryadviserperformancereport/searchsummaryadviserperformancereportcount',
            method: 'post',
            data: data,
        })
    },
    searchSummaryAdviserPerformanceReportByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/summaryadviserperformancereport/searchsummaryadviserperformancereportbypage',
            method: 'post',
            data: data,
        })
    },
    exportSummaryAdviserPerformanceReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/summaryadviserperformancereport/exportsummaryadviserperformancereport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/report/summaryadviserperformancereport.js